var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ps_account text-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.connectSSO()}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }